import React, { useContext, useEffect, useState } from "react"
import { MdAddCircle, MdSwapVert } from "react-icons/md"
import { Table } from "react-bootstrap"
import UsuarioContext from "../Context/Usuario"
import { Link } from "react-router-dom"
import "./MisCohortes.css"
import UAI from "../UAI"
import TituloVista from "../Utils/TituloVista"

const MisCohortes = (props) => {
  const { usuario } = useContext(UsuarioContext)
  const [tipo, setTipo] = useState("unidadventa")

  useEffect(() => {
    if (usuario.tabType) {
      if (usuario.tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES) {
        setTipo("unidadventa")
      } else {
        setTipo("facultad")
      }
    }
  }, [usuario])

  let filas =
    tipo === "unidadventa"
      ? Object.values(usuario.facultades)
      : Object.values(usuario.unidadesventa)
  let columnas =
    tipo === "unidadventa"
      ? Object.values(usuario.unidadesventa)
      : Object.values(usuario.facultades)
  let titulo =
    tipo === "facultad"
      ? "Unidad de Admisión / Facultad-Escuela"
      : "Facultad-Escuela / Unidad de Admisión"
  return (
    <>
    <TituloVista
      title={"Mis cohortes " + usuario.periodo}
      vista={UAI.obtieneVistaUsuarioPorCodigo(usuario,"home")}
      botones={<Link to="/crearcohorte" title="Nueva cohorte o actividad"><MdAddCircle className="text-primary crear-cohorte" size="3rem" role="button"/></Link>}
      />

      <Table size="sm" bordered className="misuv">
        <thead>
          <tr>
            <th>
              {titulo}
              <MdSwapVert
                className="swapUvFac"
                onClick={() => {
                  setTipo(tipo === "facultad" ? "unidadventa" : "facultad")
                }}
                role="button"
              />
            </th>
            {columnas.map((columna, idx) => {
              return (
                <th
                  key={idx}
                  className={"facuv " + (idx === 0 ? " first-" + tipo : "")}
                >
                  {columna.nombre}
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {filas.map((fila, idx) => {
            return (
              <tr key={idx}>
                <td
                  className={
                    idx === 0
                      ? "first-" +
                        (tipo === "facultad" ? "unidadventa" : "facultad")
                      : ""
                  }
                >
                  {fila.nombre}
                </td>
                {columnas.map((columna, idx) => {
                  let facultad = tipo === "unidadventa" ? fila : columna
                  let unidadventa = tipo === "unidadventa" ? columna : fila
                  let facultadcohortes =
                    unidadventa.facultades[facultad.nombrecorto] || {}
                  let total = Object.values(facultadcohortes).filter((fc) => {
                    return fc.Periodo
                  }).length
                  return (
                    <td key={idx} className="facuv">
                      {total > 0 ? (
                        <>
                          <Link
                            className="link-facuv"
                            to={
                              "/cohortes/info-general/" +
                              facultad.nombrecorto +
                              "+" +
                              unidadventa.nombrecorto
                            }
                          >
                            {total}
                          </Link>
                        </>
                      ) : (
                        ""
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
    </>
  )
}

export default MisCohortes
